import { API_BASE } from "../config/api";
import { httpRequest } from "../utils/httpClient";
import { authService } from "./auth";

export const gamesService = {
  async fetchGameDetails(gameId) {
    if (!gameId) {
      throw new Error("gameId is required");
    }

    const response = await httpRequest(`${API_BASE}/games/${gameId}/details`, {
      method: "GET",
      headers: authService.getAuthHeaders(),
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch game details for id=${gameId}`);
    }

    return response.json();
  },
};
